import RootState from 'state/RootState';

export type CommandFunction = (
  dispatch: Function,
  getState: () => RootState
) => void;

export class Command {
  canMerge = false;
  execute(firstTime?: boolean): CommandFunction {
    throw new Error('Not Implemented');
  }

  undo(): CommandFunction {
    throw new Error('Not Implemented');
  }

  merge(nextCommand: Command) {
    // throw new Error('Not Implemented');
  }
}



// WEBPACK FOOTER //
// ./src/state/commands/Command.ts